import React from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@shared/ui/card";
import { Badge } from "@shared/ui/badge";
import { ThumbsUp } from "lucide-react";

interface RecentFAQsProps {
  dashboardData?: {
    topFaqs: Array<{
      code: string;
      name: string;
      isHelpful: number;
      createdBy: string;
      createdDate: string;
      utilityService: string;
      faqCategory: string;
    }>;
  };
}

export const RecentFAQs = ({ dashboardData }: RecentFAQsProps) => {
  if (!dashboardData?.topFaqs) return null;

  return (
    <Card>
      <CardHeader className="pb-4">
        <CardTitle className="card-heading-text">Recent FAQs</CardTitle>
        <CardDescription className="card-subheading-text">Latest frequently asked questions</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-3">
          {dashboardData.topFaqs.map((faq, index) => (
            <div key={index} className="flex items-center justify-between p-3 border rounded-lg">
              <div className="flex-1">
                <p className="font-medium text-sm line-clamp-1">{faq.name}</p>
                <div className="flex items-center gap-2 mt-1">
                  <Badge variant="secondary" className="text-xs">{faq.faqCategory}</Badge>
                  <Badge variant="default" className="text-xs">
                    active
                  </Badge>
                </div>
              </div>
              <div className="flex items-center gap-1 text-sm">
                <ThumbsUp className={`h-3 w-3 ${faq.isHelpful ? "text-green-500" : "text-gray-400"}`} />
                <span className="font-medium">{faq.isHelpful }</span>
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};